/* Rewrites the dermatologist band that luma-fx.js injects so that:
     - the quote is verbatim from the primary source
     - the credentials are spelled out, and the publication is named and linked, so it
       reads unmistakably as a sourced expert citation
     - the card attributed to a non-existent "Dermatology consensus" is removed
     - the heading no longer implies this product was studied
   Copy comes from snippets/luma-derm.liquid so it is translatable. */
(function(){
var D=window.LUMA_DERM; if(!D) return;

function apply(){
  var sec=document.querySelector('.lp .dermsec'); if(!sec) return false;
  if(sec.dataset.lumaDerm) return true;

  var kh=sec.querySelector('.kh'); if(kh) kh.textContent=D.eyebrow;
  var bh=sec.querySelector('.bh'); if(bh) bh.textContent=D.heading;

  var cards=sec.querySelectorAll('.dermgrid > *');
  var kept=0;
  cards.forEach(function(card){
    var nameEl=card.querySelector('.dn');
    var name=nameEl?nameEl.textContent.trim():'';
    if(D.drop_attributions.some(function(bad){ return name.indexOf(bad)>-1; })){
      card.parentNode.removeChild(card); return;
    }
    if(/engelman/i.test(name)){
      var q=card.querySelector('.dq, blockquote, p');
      if(q) q.textContent='“'+D.quote+'”';
      if(nameEl){
        nameEl.innerHTML='';
        var n=document.createElement('span'); n.className='lderm-name'; n.textContent=D.name;
        var c=document.createElement('span'); c.className='lderm-cred'; c.textContent=D.credential;
        var p=document.createElement('span'); p.className='lderm-pub';
        var a=document.createElement('a');
        a.href=D.source_url; a.target='_blank'; a.rel='noopener nofollow';
        a.textContent=D.publication;
        p.appendChild(a);
        nameEl.appendChild(n); nameEl.appendChild(c); nameEl.appendChild(p);
      }
    }
    kept++;
  });

  var src=sec.querySelector('.dsrc');
  if(src) src.textContent=D.disclaimer;

  if(kept===0){ sec.parentNode.removeChild(sec); return true; }
  sec.dataset.lumaDerm='1';
  return true;
}

document.addEventListener('DOMContentLoaded',function(){
  if(apply()) return;
  var n=0,iv=setInterval(function(){ n++; if(apply()||n>40) clearInterval(iv); },100);
});
window.addEventListener('load',function(){ [400,1400].forEach(function(t){ setTimeout(apply,t); }); });
})();